import axios from 'axios';

// Constants for OpenStreetMap Nominatim API 
const OSM_API_URL = 'https://nominatim.openstreetmap.org';

// Create a separate axios instance for external OSM API calls
const osmApi = axios.create({
  baseURL: OSM_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a delay between requests to respect OSM usage policy
let lastRequestTime = 0;
const MIN_REQUEST_DELAY = 1000; // 1 second delay between requests

// Add request interceptor to enforce rate limiting
osmApi.interceptors.request.use(async (config) => {
  const now = Date.now();
  const timeElapsed = now - lastRequestTime;
  
  if (timeElapsed < MIN_REQUEST_DELAY) {
    // Wait for the remaining time
    await new Promise(resolve => setTimeout(resolve, MIN_REQUEST_DELAY - timeElapsed));
  }
  
  lastRequestTime = Date.now();
  return config;
});

export const osmService = {
  // Search for cities or locations by name
  getCityInfo: async (query: string) => {
    const response = await osmApi.get('/search', {
      params: {
        q: query,
        format: 'json',
        addressdetails: 1,
        limit: 10,
        countrycodes: 'fr' // Limit to France, can be modified or made configurable
      }
    });
    return response.data;
  },
  
  // Reverse geocoding - get location info from coordinates
  getLocationFromCoordinates: async (lat: number, lon: number) => {
    const response = await osmApi.get('/reverse', {
      params: {
        lat,
        lon,
        format: 'json',
        addressdetails: 1,
        zoom: 18,
        namedetails: 1
      }
    });
    return response.data;
  }
};